import { render, staticRenderFns } from "./OnboardingWelcomePage.vue?vue&type=template&id=57172e09&scoped=true&"
import script from "./OnboardingWelcomePage.vue?vue&type=script&lang=js&"
export * from "./OnboardingWelcomePage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingWelcomePage.vue?vue&type=style&index=0&id=57172e09&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57172e09",
  null
  
)

export default component.exports